<template>
  <div class="base">
    <inside-header color="grey" title="我的账户" />
    <div class="main">
      <div class="withdrawal-panel">
        <van-notice-bar wrapable :scrollable="false"
          text="申请提交后，您的提现金额将会冻结。我们会在24小时内处理您的提现申请。您在一天内最多可提现3次，单次提现的资金上限为100元。" />
        <div class="title">
          <span class="icon">
            <van-icon name="alipay" />
          </span>
          <span class="label">提现到支付宝（{{ auth_real_name }}）</span>
        </div>
        <div class="input-alipay-account">
          <a-input v-model="accountNumber" placeholder="请输入支付宝账号" />
        </div>
      </div>
    </div>
    <div class="withdrawal-area">
      <div class="title">
        <span>提现金额</span>
        <span>
          <a-tooltip placement="bottom" style="cursor: pointer;">
            <template slot="title">
              <span>当前推广收益为{{ undrawn_income }}元，支持10的倍数进行提现</span>
            </template>
            <span>&nbsp;&nbsp;
              <a-icon style="color: #999;" type="question-circle" />
            </span>
          </a-tooltip>
        </span>
      </div>
      <div class="total">
        <a-input v-model="ableIncome" prefix="￥" suffix="RMB" size="large" />
      </div>
      <div class="show">
        <span class="cash">
          当前未提现金额{{ undrawn_income }}，可提现金额{{ withdrawableIncome }}元，
        </span>
        <span class="all-cash" @click="goIncome">
          全部提现
        </span>
      </div>
      <div class="btn-area">
        <a-button block type="primary" @click="withdrawalStart()">
          立即提现
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

export default {
  name: 'UserPromoteWithDrawal',
  components: {
    InsideHeader
  },
  data() {
    return {
      withdrawableIncome: '',
      ableIncome: '',
      accountNumber: '',
      auth_real_name: '',
      undrawn_income: ''
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
    this.loadData()
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
    loadData() {
      this.$http({
        url: 'index/promote/withdrawnDetails',
        method: 'get'
      }).then(res => {
        console.log(1, res)
        var data = res.data
        this.withdrawableIncome = data.withdrawable_income
        this.auth_real_name = data.auth_real_name
        this.undrawn_income = data.undrawn_income
      })
    },
    goIncome() {
      this.ableIncome = this.withdrawableIncome
    },
    withdrawalStart() {
      // 判断
      if (this.accountNumber === '') {
        this.$toast.fail('请输入支付宝账号~')
        return false
      }
      if (this.ableIncome === '') {
        this.$toast.fail('请输入提现金额~')
        return false
      }
      this.$http({
        url: 'index/promote/withdrawn',
        method: 'post',
        data: {
          alipay_account: this.accountNumber,
          withdrawal_amount: this.ableIncome
        }
      }).then(res => {
        if (res.status === 'success') {
          this.$toast('提现成功')
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
    background-color: #f6f6f6;

    .withdrawal-panel {
      padding: 15px;
      background-color: #ffffff;
      border-radius: 10px;

      .title {
        margin-top: 20px;
        line-height: 15px;

        .icon {
          color: #3773f1
          position: relative;
          top: 1px;
        }

        .label {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 14px;
          color: #333333;

          margin-left: 5px;
        }
      }

      .input-alipay-account {
        margin-top: 16px;

        input {
          width: 315px;
          height: 40px;
          border-radius: 10px;
          border: solid 1px #f0f0f0;
        }
      }
    }
  }

  .withdrawal-area {
    padding: 30px;
    background-color: #fff;
    border-radius: 25px;

    .title {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 19px;
      color: #333333;
    }

    .total {
      margin-top: 15px;
      padding-top: 15px;
      padding-bottom: 15px;

      .prefix {
        font-family: PingFang-SC-Medium;
        font-size: 18px;
        line-height: 19px;
        color: #333333;
      }

      .money {
        font-family: Bahnschrift;
        font-size: 36px;
        line-height: 14px;
        color: #333333;

        margin-left: 5px;
      }

      border-bottom: 1px solid #eee;
    }

    .show {
      margin-top: 15px;

      .cash {
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        line-height: 19px;
        color: #666666;
      }

      .all-cash {
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        color: #ff5c00;
      }
    }

    .btn-area {
      margin-top: 60px;

      button {
        height: 40px;
        background-color: #ff5c00;
        border-radius: 10px;
      }
    }
  }
</style>
